import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  variant?: 'primary' | 'secondary';
  href?: string;
  onNavigate?: () => void;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  variant = 'primary',
  href,
  onNavigate,
  ...props
}: ButtonProps) {
  const baseStyles = 'font-heading font-bold rounded-full transition-all duration-300 ease-out flex items-center justify-center';
  const variants = {
    primary: 'bg-gradient-to-r from-[#E8636F] to-[#F4A261] text-white shadow-[0_0_20px_rgba(232,99,111,0.3)] hover:shadow-[0_0_30px_rgba(232,99,111,0.5)]',
    secondary: 'bg-white/10 text-white hover:bg-white/20 border border-white/10 backdrop-blur-sm'
  };
  const allClasses = `
    ${baseStyles}
    ${variants[variant]}
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" onClick={() => onNavigate?.()} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.98
    }} className={allClasses} data-id="element-240">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.98
  }} className={allClasses} {...props} data-id="element-241">
      {children}
    </motion.button>;
}